import { Tooltip, Typography } from '@material-ui/core';
import { DefaultCard } from '../components/default-card';
import { useDefaultCardStyles } from '../components/default-card/default-card-styles';
import { CardParametroOpcaoProps } from './card-parametro-opcao-props';
import { OkIcon } from 'views/components/icons';
import { useStyles } from './card-parametro-opcao-styles';

export const CardParametroOpcao = ({
    model,
    onClick,
    onCheck,
    selected,
}: CardParametroOpcaoProps) => {
    const classes = useDefaultCardStyles();
    const classesCard = useStyles();

    return (
        <>
            <DefaultCard
                isSelected={selected}
                className={classesCard.container}
                onClick={() => {
                    onClick(model);
                }}
            >
                <div className={classes.cardContent}>
                    <div className={classes.celulaGrid}>
                        <Typography
                            className={'celula-grid-value'}
                            color="primary"
                            variant="caption"
                        >
                            Nome
                        </Typography>
                        <Typography
                            color="textPrimary"
                            variant="body1"
                        >
                            <strong>{model.descricao}</strong>
                        </Typography>

                    </div>
                    <div className={classes.celulaGrid}>
                        <Typography
                            className={'celula-grid-value'}
                            color="primary"
                            variant="caption"
                        >
                            Padrão
                        </Typography>
                        <Typography
                            color="textPrimary"
                            variant="body1"
                        >
                            <strong>{model.padrao ? 'Sim' : 'Não'}</strong>
                        </Typography>
                    </div>
                </div>
                <Tooltip arrow title="Aplicar Opção">
                    <div className={classes.cardRightButton}>
                        <OkIcon tipo="BUTTON" />
                    </div>
                </Tooltip>
            </DefaultCard>
        </>
    );
};
